import { useTranslation } from "react-i18next";
import { useContext } from "react";

import { Text } from "@pentabd/ui";
import { ModuleCards, UserInfo } from "./components";

import { DashboardContext, DashboardContextType } from "../../router";

const Home = () => {
  const { t } = useTranslation();

  const dashboardContext = useContext(DashboardContext);
  const { handleModuleSelection } = dashboardContext as DashboardContextType;

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <Text size="lg" weight="semibold">
        {t("DASHBOARD.HEADER")}
      </Text>
      <UserInfo />
      <ModuleCards handleModuleSelection={handleModuleSelection} />
    </div>
  );
};

export default Home;
